import { render, staticRenderFns } from "./AddTiaoWen.vue?vue&type=template&id=0acd1ac0&scoped=true"
import script from "./AddTiaoWen.vue?vue&type=script&lang=js"
export * from "./AddTiaoWen.vue?vue&type=script&lang=js"
import style0 from "./AddTiaoWen.vue?vue&type=style&index=0&id=0acd1ac0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acd1ac0",
  null
  
)

export default component.exports